import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const TrackingPixels = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get(`${API}/tracking-pixels-config`);
        setConfig(response.data);
      } catch (error) {
        console.log('Tracking config not available');
      }
    };
    fetchConfig();
  }, []);

  useEffect(() => {
    if (!config) return;

    // Initialize Facebook Pixel
    if (config.facebook_pixel_id) {
      // Facebook Pixel base code
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      
      window.fbq('init', config.facebook_pixel_id);
      window.fbq('track', 'PageView');
      
      console.log('Facebook Pixel initialized:', config.facebook_pixel_id);
    }

    // Initialize TikTok Pixel
    if (config.tiktok_pixel_id) {
      !function (w, d, t) {
        w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
        
        ttq.load(config.tiktok_pixel_id);
        ttq.page();
      }(window, document, 'ttq');
      
      console.log('TikTok Pixel initialized:', config.tiktok_pixel_id);
    }
  }, [config]);

  return null; // This component doesn't render anything
};

// Helper functions to track events
export const trackEvent = (eventName, data = {}) => {
  // Facebook Pixel
  if (window.fbq) {
    window.fbq('track', eventName, data);
  }
  
  // TikTok Pixel
  if (window.ttq) {
    window.ttq.track(eventName, data);
  }
};

export const trackViewContent = (product) => {
  const data = {
    content_type: 'product',
    content_id: product.id,
    content_name: product.name,
    content_category: product.category,
    value: product.price,
    currency: 'USD'
  };
  
  if (window.fbq) {
    window.fbq('track', 'ViewContent', data);
  }
  
  if (window.ttq) {
    window.ttq.track('ViewContent', {
      contents: [{ content_id: product.id, content_name: product.name, price: product.price }],
      value: product.price,
      currency: 'USD'
    });
  }
};

export const trackAddToCart = (product, quantity = 1) => {
  const data = {
    content_type: 'product',
    content_ids: [product.id],
    content_name: product.name,
    value: product.price * quantity,
    currency: 'USD',
    num_items: quantity
  };
  
  if (window.fbq) {
    window.fbq('track', 'AddToCart', data);
  }
  
  if (window.ttq) {
    window.ttq.track('AddToCart', {
      contents: [{ content_id: product.id, content_name: product.name, quantity, price: product.price }],
      value: product.price * quantity,
      currency: 'USD'
    });
  }
};

export const trackInitiateCheckout = (cart, total) => {
  const contentIds = cart.items?.map(item => item.product_id) || [];
  
  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_ids: contentIds,
      value: total,
      currency: 'USD',
      num_items: cart.items?.length || 0
    });
  }
  
  if (window.ttq) {
    window.ttq.track('InitiateCheckout', {
      contents: cart.items?.map(item => ({
        content_id: item.product_id,
        content_name: item.name,
        quantity: item.quantity,
        price: item.price
      })) || [],
      value: total,
      currency: 'USD'
    });
  }
};

export const trackPurchase = (order, total) => {
  const contentIds = order.items?.map(item => item.product_id) || [];
  
  if (window.fbq) {
    window.fbq('track', 'Purchase', {
      content_ids: contentIds,
      content_type: 'product',
      value: total,
      currency: 'USD',
      num_items: order.items?.length || 0
    });
  }
  
  if (window.ttq) {
    window.ttq.track('CompletePayment', {
      contents: order.items?.map(item => ({
        content_id: item.product_id,
        content_name: item.name,
        quantity: item.quantity,
        price: item.price
      })) || [],
      value: total,
      currency: 'USD'
    });
  }
};

export default TrackingPixels;
